// extracted by css-extract-rspack-plugin
export default {"container":"CRNQVY1___container","group-title":"koWrJ8f___group-title","groupTitle":"koWrJ8f___group-title","group-list":"PXrIAk6___group-list","groupList":"PXrIAk6___group-list"};